import React from 'react';
import isEmpty from 'lodash/isEmpty';
import clsx from 'clsx';

import styles from 'styles/components/profile/ProfileRating.module.scss';

const grey = { color: '#c8ccd9' };

const ProfileRating = ({ newStyles = {}, rating }) => {
  const noRating = rating === 0 || rating === null || rating === undefined;

  return (
    <div
      className={clsx(styles.ratingContainer, { [newStyles.ratingContainer]: !isEmpty(newStyles) })}
    >
      <h6 style={noRating ? grey : {}}>{noRating ? 'No rating' : `${rating}% Rating`}</h6>

      <div className={styles.success} style={{ width: noRating ? 0 : rating }} />
      <div className={styles.background} />
    </div>
  );
};

export default ProfileRating;
